import { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { User, Lock, LogIn, Loader2 } from "lucide-react";
import { useToast } from "../hooks/use-toast";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();
  const { login } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast({ title: "Error", description: "Please enter both username and password", variant: "destructive" });
      return;
    }
    setLoading(true);
    try {
      const u = await login(username, password);
      toast({ title: "Welcome back!", description: u.name });
    } catch (err) {
      toast({
        title: "Sign in failed",
        description: err?.response?.data?.detail || "Invalid credentials",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen login-bg flex items-center justify-center p-6">
      <div className="relative w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="gradient-blue-mild py-8 px-8 text-center">
            <div className="inline-flex items-center justify-center mb-3">
              <img
                src="/assets/ohr-hatorah-logo.png"
                alt="תלמוד תורה אור התורה"
                className="w-40 h-40 object-contain drop-shadow-lg"
              />
            </div>
            <div className="text-white/70 text-xs mt-1 font-en tracking-widest">OHR HATORAH · LATE PASS SYSTEM</div>
          </div>

          <form onSubmit={submit} className="p-8 space-y-5">
            <div className="text-center mb-4">
              <h2 className="text-lg font-semibold text-slate-800">Sign In</h2>
              <p className="text-xs text-slate-500 mt-1">Enter your credentials to continue</p>
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium text-slate-700 flex items-center gap-2">
                <User className="w-4 h-4 text-slate-500" />
                Username
              </label>
              <Input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="admin" className="h-11" autoComplete="username" />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium text-slate-700 flex items-center gap-2">
                <Lock className="w-4 h-4 text-slate-500" />
                Password
              </label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="h-11" autoComplete="current-password" />
            </div>

            <Button type="submit" disabled={loading} className="w-full h-11 gradient-blue-mild text-white hover:opacity-95 shadow-md">
              {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <LogIn className="w-4 h-4 mr-2" />}
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </div>

        <div className="text-center text-white/60 text-xs mt-6 font-en">
          © 2025 Ohr HaTorah · All Rights Reserved
        </div>
      </div>
    </div>
  );
}
